export default {
    methods: {
        async buildQueryParam(page, first_name, middle_name, last_name, email, birth_month,
                              marital_status, wofbi_status, water_baptism, service_unit,
                              attendance_month, attendance_year, size, sort) {

            const params = new URLSearchParams();
            params.append('page', isNaN(page) ? '0' : (page - 1).toString());
            size = size || localStorage.getItem('page_size') || '10';
            params.append('size', size.toString().trim());

            const optionalParams = {
                first_name,
                middle_name,
                last_name,
                email,
                birthday_month: birth_month,
                marital_status,
                wofbi_status,
                water_baptism,
                service_unit,
                attendance_month,
                attendance_year,
                sort
            };

            for (const [key, value] of Object.entries(optionalParams)) {
                if (value !== undefined && value !== null && value !== '') {
                    params.append(key, value.toString());
                }
            }

            return params.toString();
        },

        async getContacts(queryParam) {
            let url = `${this.appServer}/contacts?${queryParam}`
            let result = await this.$axios.get(url);
            if (result.status === 200) {
                if (result.data._embedded) {
                    this.$store.commit('updateContactList', result.data._embedded.contacts);
                    return result;
                }
            } else {
                return {};
            }
        },

        async sendSmsToContacts(queryParam, smsMessage) {

            let url = `${this.appServer}/contacts/sms?${queryParam}`

            let result = await this.$axios.post(url, {
                from: 'WCI-CAMB',
                body: smsMessage
            });

            if (result.status === 200) {
                alert("success")
            } else {
                return {};
            }
        },

        async findContactsById(userId) {
            let result = await this.$axios.get(`${this.appServer}/contacts/${userId}`);
            if (result.status === 200) {
                if (result.data) {
                    this.$store.commit('updateContact', result.data)
                    return result.data;
                } else {
                    return {};
                }
            }
        },

        async saveContact(state) {
            state.birthday_month = Number(state.birthday_month)
            state.birthday_day = Number(state.birthday_day)
            alert(state.birthday_month)
            alert(state.birthday_day)
            let result = {};
            let report = "";
            let url = `${this.appServer}/contacts`;

            if (state.id) {
                alert(JSON.stringify(state))
                result = await this.$axios.put(`${url}/${state.id}`, state);
                if (result.status === 200) {
                    this.$store.commit('updateContact', state);
                    report = {success: true, details: "Contact was successfully updated"}
                }
            } else {
                result = await this.$axios.post(url, state);
                if (result.status === 201) {
                    let contacts = this.$store.state.contact_list;
                    contacts.unshift(result.data.post);
                    this.$store.commit('updateContact', result.data.post);
                    this.$store.commit('updateContactList', contacts);
                    report = {success: true, details: "Contact successfully created"}
                }
            }
            return report;
        },

        async deleteContact(userId) {
            let result = await this.$axios.delete(`${this.appServer}/contacts/${userId}`);
            if (result.status === 200) {
                if (result.data) {
                    return result.data;
                } else {
                    return {};
                }
            }
        },

        async getDashboardReport(type, year) {

            type = (type === undefined) ? '' : `type=${type}`;
            year = (year === undefined) ? '' : `year=${year}`;
            let url = `${this.appServer}/contacts/reports?${type}&${year}`
            let result = await this.$axios.get(url);
            if (result.status === 200) {
                if (result.data) {
                    return result;
                }
            } else {
                return {};
            }
        },

        async exportContacts(searchParams) {
            let exportUrl = `${this.appServer}/contacts/export?${searchParams}`;
            console.log(exportUrl);

            try {
                const response = await this.$axios.get(exportUrl, {params: "", responseType: "blob"});
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                // Create a download link
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = "contacts.xlsx";
                document.body.appendChild(link);
                link.click();

                // Cleanup
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error("Export failed:", error);
            }
        },

        async downloadContactsTemplate() {
            try {
                const response = await this.$axios.get(`${this.appServer}/contacts/templates`, { responseType: "blob" });
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = "contacts-template.xlsx";
                link.click();
                window.URL.revokeObjectURL(url);
            } catch (err) {
                console.error("Download failed:", err);
            }
        },

        async patchContactPhoto(id, formData) {
            let result = await this.$axios.patch(`${this.appServer}/contacts/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return result;
        }
    }
};
